import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import {
  blackColor,
  blackColor26,
  blackColor27,
  borderColor,
  headingColor,
  whiteColor,
} from "configs/styles/muiThemes";
import React from "react";
import MapComponent from "./MapComponent";
import BusinessInfoCard from "./BusinessInfoCard";
import MapIcon from "@mui/icons-material/Map";
import PersonIcon from "@mui/icons-material/Person";
import InputPreview from "components/InputPreview";

function BusinessInfoMobileCard({ data }) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <Box px={2} pt="10px" pb={8} backgroundColor={whiteColor}>
      <Typography
        variant="h2"
        fontSize={{ md: "19px", xs: "13px" }}
        fontWeight={600}
        align="left"
        color={blackColor27}
        mb="10px !important"
      >
        Business Info
      </Typography>
      {data && (
        <>
          <Box mt={2}>
            <InfoCard
              iconUrl="https://storage.googleapis.com/bodefaults/shopweb/reviews/contact.svg"
              label="Contact Name"
              value={data?.ownerName}
            />
            <InfoCard
              iconUrl="https://storage.googleapis.com/bodefaults/shopweb/reviews/phone.svg"
              label="Phone Number"
              value={data?.phone}
            />
            <InfoCard
              iconUrl="https://storage.googleapis.com/bodefaults/shopweb/reviews/address.svg"
              label="Address"
              value={data?.address}
            />

            <Box>
              <Typography
                variant="h5"
                fontSize={13}
                paddingTop={0.3}
                paddingBottom={1}
                color={blackColor27}
                align="left"
              >
                Location
              </Typography>

              <MapComponent
                latitude={data.loc ? data.loc.y : 12.9716}
                longitude={data.loc ? data.loc.x : 77.5946}
              />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}

export default BusinessInfoMobileCard;

const InfoCard = ({ iconUrl, label, value }) => {
  return (
    <Box
      display={"flex"}
      gap={2}
      borderBottom={`1px solid ${borderColor}`}
      pb="8px"
      mb="8px"
    >
      <Box
        component="img"
        width={{ xs: "35px", md: "45px" }}
        heigth={{ xs: "35px", md: "45px" }}
        src={iconUrl}
        alt="CostBo"
      />

      <Box flex={1}>
        <Typography fontSize={11.5} color={blackColor26} lineHeight="16px">
          {label}
        </Typography>
        <Typography
          fontSize={12}
          color={blackColor27}
          fontWeight={500}
          lineHeight="18px"
          mt="4px"
        >
          {value}
        </Typography>
        {/* <InputPreview label={label} value={value} valueSize={12} hideBorder /> */}
      </Box>
    </Box>
  );
};
